import { RequestListContext } from '@Components/types/RequestListContext';
import { NoData } from '@Components/RequestList/noData';

import Card from './components/Card';
import styles from './request-list-mobile.module.css';
import { MaterialVendorItem } from '../../../types';

type List = Array<MaterialVendorItem>;

export interface RequestListMobileProps {
  list?: List;
  context?: RequestListContext;
  onSelect: (material: MaterialVendorItem) => void;
}

const RequestListMobile = ({
  list,
  context = 'my-requests',
  onSelect,
}: RequestListMobileProps): JSX.Element | null => {
  if (!list || !list.length) {
    return <NoData context={context} />;
  }

  return (
    <div className={styles.requestListMobile}>
      {list.map((materialVendorItem) => {
        const { material, id } = materialVendorItem;
        return (
          <Card
            key={id}
            unitName={material?.unit || ''}
            qty={material?.requiredQty}
            description={material?.description || ''}
            no={material?.code || ''}
            onClick={() => onSelect(materialVendorItem)}
          />
        );
      })}
    </div>
  );
};

export default RequestListMobile;
